module.exports = __webpack_public_path__ + "static/img/BH.6e9666b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BH.png
// module id = bxnK
// module chunks = 12